import React, { useEffect, useState, useRef } from 'react';
import { Button, Modal } from "react-bootstrap";
import { useSelector,useDispatch } from "react-redux";
import ARBProgressBar from '../Controls/ARBProgressBar.js';
import ConfirmationModal from './ConfirmationModal.js';
import APICom from '../../utils/helpers/APICom.js';
import { store , persistor} from '../../store.js';
import { SetARBResponsePersistData } from '../../features/common/ARBSlice.js';
import ForceSchedulingComponent from '../Dispatch/ForceScheduling/ForceSchedulingComponent.js';
import RouteSuggestion from "../Dispatch/RouteSuggestion.js";
import PersistStorage from "../../utils/helpers/PersistStorage";
import ModuleSecurity from "../../utils/helpers/ModuleSecurity.js";

const ARBResponseListener = (props) => {
    let lastActivityTimeARBResumedNotification = null;
    //let AutoPausingDialog = false;
    let AutoPausingModalCloseTime = null;
    let ARBAutoResumeTimer = 60;
    let ARBTimer = 1;
    let interval_playing = null;
    let _timeoutPlaying;

    const dispatch = useDispatch();
    const [showARBValidationMsg, setShowARBValidationMsg] = useState(true)
    const [AutoPausingDialog,setAutoPausingDialog]=useState(false);
    const { GlobalASCSData, ASCSSettingData } = useSelector((store) => store.combinedata);
    const { loginData } = useSelector((store) => store.login);

    const [multiPageProgressBar, setmultiPageProgressBar] = useState(false);
    const [forceData, setforceData] = useState('');
    const [stopViewGridData, setstopViewGridData] = useState('');
    const [showForceSchedulingComponent, setshowForceSchedulingComponent] = useState(false);
    const [P_MasterASCSCallerIDIframeURL, setP_MasterASCSCallerIDIframeURL] = useState("");
    const [showiFrame, setshowiFrame] = useState(false);
    const [arbProgress, setarbProgress] = useState(0);
    const [arbProgressMessage, setarbProgressMessage] = useState("Please Wait ..");
    const [showProgressBar, setshowProgressBar] = useState(false);
    const [showRouteSuggestionDialog, setRouteSuggestionDialog] = useState(false);
    const [confirmationModalObj, setConfirmationModalObj] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you sure you want to pause Auto Routing?', btnCanceText: 'No',
        btnOkText: 'Yes'
    });
    const [selectedDescription, setSelectedDescription] = useState();
    const [selectedAffiliateID, setSelectedAffiliateID] = useState();
    const [rowReArrangeCheck, setRowReArrangeCheck] = useState(false);
    const [showViolationString, setshowViolationString] = useState(false);
    const [unRoutedRefIDs, setUnRoutedRefIDs] = useState([]);
    const [isMessageVisible, setMessageVisible] = useState({show: false, title: 'Auto Routing', body: ''});
    const [showMessageDialog, setshowMessageDialog] = useState({
        "show": false,
        "Title": "",
        "Body": { __html: "", },
        "btn1_text": "",
        "btn2_text": "",
        "Showbtn1Button": false
    });
    const [showOnlyMessageDialog, setshowOnlyMessageDialog] = useState({
        "show": false,
        "Title": "",
        "Body": { __html: "", },
    });
    const [ARBModalObj, setARBModalObj] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
        btnOkText: 'Yes',
        ShowTimer: false,
        timerDuration: 60
    });
    
    const iframeRef = useRef(null);
    const displayMessageTimeout = useRef(null);
    const hideClusteringDialogTimeout = useRef(null);
    const hideRoutingDialogTimeout = useRef(null);

    //ProgressBarTimeout Reference
    const ARBSetTimeout = useRef(null);
    const ARBSetTimeout_1 = useRef(null);
    const ARBSetTimeout_2 = useRef(null);
    const ARBSetTimeout_3 = useRef(null);
    const ARBSetTimeout_4 = useRef(null);
    const ARBSetTimeout_5 = useRef(null);

    const ARBStandingRouteMakerSetTimeout = useRef(null);
    const ARBStandingRouteMakerSetTimeout_1 = useRef(null);

    const ARBRouteListenerSetTimeout = useRef(null);
    const ARBRouteListenerSetTimeout_1 = useRef(null);

    useEffect(() => {
        // console.log("ARBResponseListener mounted");
        try{
            if (GlobalASCSData && typeof GlobalASCSData !== 'undefined' && Array.isArray(GlobalASCSData) && GlobalASCSData.length > 0) {
                const jsonArray = GlobalASCSData;
                const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
                setP_MasterASCSCallerIDIframeURL(URL.value.replace('/api', ''));
            }
            else{
                setP_MasterASCSCallerIDIframeURL('google.com');
            }
            setupEventListeners();
        }
        catch(err){console.log(err);}


        try {
            if(props?.showARBValidationsMessage != undefined){
                setShowARBValidationMsg(props.showARBValidationsMessage);
            }
            else{
                setShowARBValidationMsg(true);   
            }
        } catch (error) {
            
        }

        return () => {
            if (displayMessageTimeout?.current) {
                clearTimeout(displayMessageTimeout.current);
            }
            if(hideClusteringDialogTimeout?.current){
                clearTimeout(hideClusteringDialogTimeout.current);
            }
            if(hideRoutingDialogTimeout?.current){
                clearTimeout(hideRoutingDialogTimeout.current);
            }
            if(ARBSetTimeout?.current){
                clearTimeout(ARBSetTimeout.current);
            }
            if(ARBSetTimeout_1?.current){
                clearTimeout(ARBSetTimeout_1.current);
            }
            if(ARBSetTimeout_2?.current){
                clearTimeout(ARBSetTimeout_2.current);
            }
            if(ARBSetTimeout_3?.current){
                clearTimeout(ARBSetTimeout_3.current);
            }
            if(ARBSetTimeout_4?.current){
                clearTimeout(ARBSetTimeout_4.current);
            }
            if(ARBSetTimeout_5?.current){
                clearTimeout(ARBSetTimeout_5.current);
            }
            if(ARBStandingRouteMakerSetTimeout?.current){
                clearTimeout(ARBStandingRouteMakerSetTimeout.current);
            }
            if(ARBStandingRouteMakerSetTimeout_1?.current){
                clearTimeout(ARBStandingRouteMakerSetTimeout_1.current);
            }
            if(ARBRouteListenerSetTimeout?.current){
                clearTimeout(ARBRouteListenerSetTimeout.current);
            }
            if(ARBRouteListenerSetTimeout_1?.current){
                clearTimeout(ARBRouteListenerSetTimeout_1.current);
            }
        };

    }, []);

    useEffect(() => {
        // console.log("ARBResponseListener handlePageProgressBar");
        try{
            const multiPageProgressBarFlag = ((props.handlePageProgressBar && typeof props.handlePageProgressBar !== 'undefined') ? true : false);
            setmultiPageProgressBar(multiPageProgressBarFlag);
            // if(props.handlePageProgressBar === null || props.handlePageProgressBar === undefined){
            //     setmultiPageProgressBar(false)
            // }
            // else{
            //     setmultiPageProgressBar(true)
            // }
        }
        catch(err){console.log(err);}
    }, [props.handlePageProgressBar]);

    function StartResumeNotificationTimer(affiliate_name, description, affiliate_id) {
        try{
            setARBModalObj((prevState) => ({
                ...prevState,
                show: true,
                title: affiliate_name + ` Resume Auto Routing`,
                body: `Do you want to Resume Auto-Routing for this date: ${description} ?`,
                btnCanceText: 'No',
                btnOkText: 'Yes',
                ShowTimer: true,
                timerDuration: 60
                
            }));
           // AutoPausingDialog = true;
            setAutoPausingDialog(true);
            AutoPausingModalCloseTime = null;
            /*
            interval_playing = setInterval(function()
            {
                //by parsing integer, I avoid all extra string processing
                let seconds = parseInt(ARBAutoResumeTimer, 10);
                --seconds;
                seconds = (seconds < 10) ? '0' + seconds : seconds;
                console.log(seconds);
                setARBModalObj((prevState) => ({
                                ...prevState,
                                title: affiliate_name + ` Resume Auto Routing | ${seconds}s`,
                            }));
    
                ARBAutoResumeTimer = seconds;
                if (seconds <= 0) {
                    debugger;
                    clearInterval(interval_playing);
                    AutoPausingDialog= false;
                    setARBModalObj((prevState) => ({ ...prevState, show: false }));
                    SaveRBSStatus("ResumedARBAutoRouting", 0, description, affiliate_id, 1);
                    console.log("Timer is zero");
                }
            }, 1000);
            */
        }
        catch(err){console.log(err);}
    }

    // function ResumeTimerFunction() {
        
    // }

    function TimerFunction() {
        try{
            setTimeout(function () {
                if (ARBTimer <= 0) {
                    handleConfirmationModalButtonPress(2);
                    return;
                }
                ARBTimer--;
                TimerFunction();
                setARBModalObj((prevState) => ({
                    ...prevState,
                    title: ` Resume Auto Routing in | ${ARBTimer}s`,
                }));
            }, 1000);
        }
        catch(err){console.log(err);}
    }

    // function startTimer(description, affiliate_id, affiliate_name) {
    //     try{
    //         if (ARBAutoResumeTimer >= 59) {
    //             setSelectedDescription(description);
    //             setSelectedAffiliateID(affiliate_id);
    
    //             setARBModalObj((prevState) => ({
    //                 ...prevState,
    //                 show: true,
    //                 title: affiliate_name + ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
    //                 body: `Do you want to Resume Auto-Routing for this date: ${description} ?`,
    //                 btnCanceText: 'No',
    //                 btnOkText: 'Yes',
    //             }));
    
    //             function updateTimer(description, affiliate_id, affiliate_name) {
    //                 if (ARBAutoResumeTimer <= 0) {
    //                     ARBAutoResumeTimer = 60;
    //                     setARBModalObj((prevState) => ({ ...prevState, show: false }));
    //                     SaveRBSStatus("ResumedARBAutoRouting", 0, description, affiliate_id, 1);
    //                     console.log("Timer is zero");
    //                 } else {
    //                     ARBAutoResumeTimer--;
    //                     setARBModalObj((prevState) => ({
    //                         ...prevState,
    //                         title: affiliate_name + ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
    //                     }));
    //                     _timeoutPlaying = setTimeout(updateTimer(description, affiliate_id, affiliate_name), 1000);
    //                 }
    //             }
    //             updateTimer();
    //         }
    //     }
    //     catch(err){console.log(err);}
    // }

    // const handleOnTimerExpire = () => {
    //     handleConfirmationModalButtonPress();
    // };

    // const handleCloseButton = () => {
    //     handleNoButton();
    // };

    const handleConfirmationModalButtonPress = (pauseAutoRoute = 0) => {
        try{ 
            //iPauseAutoRouting = 2: When User click on No button, iPauseAutoRouting = 0: form AutoResume Popup on Yes button click
            SaveRBSStatus("ResumedARBAutoRouting", pauseAutoRoute, selectedDescription, selectedAffiliateID, 1);
            ARBTimer = -2;
            let currentTime = new Date(); // You can format this as needed
           // AutoPausingDialog = false;
            setAutoPausingDialog(false);
            AutoPausingModalCloseTime = currentTime;
            setARBModalObj((prevState) => ({ ...prevState, show: false }));
            if (typeof interval_playing !== 'undefined' && interval_playing){
                clearInterval(interval_playing);
            }
        }
        catch(err){console.log(err);}
    };

    // const handleNoButton = () => {
    //     try{
    //         SaveRBSStatus("ResumedARBAutoRouting", 2, selectedDescription, selectedAffiliateID, 1); //iPauseAutoRouting=2: When User click on No button, 1 form AutoResume Popup
    //         let currentTime = new Date(); // You can format this as needed
    //         ARBTimer = -1;
    //         AutoPausingDialog = false;
    //         AutoPausingModalCloseTime = currentTime;
    //         setARBModalObj((prevState) => ({ ...prevState, show: false }));
    //         if (interval_playing !== undefined && interval_playing !== null)
    //             clearInterval(interval_playing);
    //     }
    //     catch(err){console.log(err);}
    // };

    const handleIframeLoad = () => {
        try{
            // const iframe = document.getElementById('WMRMSCommonComifra');
            // iframe.contentWindow.postMessage(loginData.iUserID, '*');
            if(iframeRef.current)
            {
                iframeRef.current.contentWindow.postMessage(loginData.iUserID, '*');
            }
        }
        catch(err){console.log(err);}
    };

    // const handleIframeClose = () => {
    //     setshowiFrame(false);
    // };

    const handleCloseClusteringDialog = () => {
        props.setGridRefreshPaused(false);
        setshowMessageDialog({
            "show": false,
            "Title": "",
            "Body": { __html: "", },
            "btn1_text": "",
            "btn2_text": "",
            "Showbtn1Button": false
        });
    };

    const handleCloseOnlyMessageDialog = () => {
        props.setGridRefreshPaused(false);
        setshowOnlyMessageDialog({
            "show": false,
            "Title": "",
            "Body": { __html: "", },
        });
    };

    const displayMessage = (text) => {
        setMessageVisible((prevState) => ({ ...prevState, show: true, body: text}));
        displayMessageTimeout.current = setTimeout(() => {
            setMessageVisible((prevState) => ({ ...prevState, show: false, body: ""}));
        }, 2000); 
    };

    const handleForceDispatch = () => {
        try{
            let storedDataJSON = sessionStorage.getItem('RecordIDs');
            let storedData = JSON.parse(storedDataJSON);
            
            // If unRoutedRefIDs is not null or empty, filter the vServiceIDs and vScheduleIDs
            if (unRoutedRefIDs && unRoutedRefIDs.length > 0) {
                // Filter the normalizedSelectedData based on unRoutedRefIDs
                let filteredData = storedData.normalizedSelectedData.filter(item => unRoutedRefIDs.includes(item.iRefId));
    
                // Update vServiceIDs and vScheduleIDs based on the filtered data
                storedData.vServiceIDs = filteredData.map(item => item.ServiceID).join(',');
                storedData.vScheduleIDs = filteredData.map(item => item.iScheduleID).join(',');
                storedData.SelectedRecordsForARB = storedData.SelectedRecordsForARB.filter(item => unRoutedRefIDs.includes(item.Confirmation));
            }
    
            PersistStorage.save("AffiliateID", storedData.affID, 999, false);
            PersistStorage.save("ARBSelectedOption",'ForceScheduling', 999, false);
            NewRouteForcefullly(storedData.vServiceIDs, storedData.vScheduleIDs, storedData.pickupDateTime, storedData.affID, "0", 
                storedData.manifestNumber, false, storedData.callBackURL, storedData.SelectedRecordsForARB, String(storedData.SelectedRouteSettingID)
            );
            setshowMessageDialog(false);
            handleCloseOnlyMessageDialog();
            props.setGridRefreshPaused(true);
        }
        catch(err){console.log(err);}
    };

    const setupEventListeners = () => {
        try {
            let eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            // let eventer = window[eventMethod];
            let messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
            //window.addEventListener(messageEvent, ARBResponseListener_NewRequestHTML);
            //window.addEventListener(messageEvent, ARBResponseListener_RBSProcess);
            // window.addEventListener(messageEvent, ARBResponseListener_StandingRouteMaker);
            // window.addEventListener(messageEvent, ARBResponseListener_RouteMaker);
            window.addEventListener(messageEvent, ARBResponseListener_Identifer);
        }
        catch (ee) {console.log('ARBResponseListener Setup Error: ' + ee);}
    };

    const hideRoutingClusteringDialog = (bRefreshGrid = true, type = '') => {
        try{
            setarbProgress(100);
            if (bRefreshGrid && typeof props.GridRefresh === 'function'){
                props.GridRefresh();
            }
            const timeOutRef = (type === 'cluster' ? hideClusteringDialogTimeout : hideRoutingDialogTimeout);
            const funcShowDialog = (type === 'cluster' ? props.setShowClusterDialog : props.setManifestBuildDialog);
            const funcShowDialog2 = (type === 'cluster' ? props.setShowClusterDialog : props?.onDialogStateChange);

            timeOutRef.current = setTimeout(() => {
                setshowProgressBar(false);
                if(typeof funcShowDialog === 'function'){
                    funcShowDialog(false);
                    if(typeof funcShowDialog2 === 'function' && funcShowDialog2){
                    funcShowDialog2(false);
                    } 
                }
            }, 2000);
            
        }
        catch(err){console.log(err);}
    };

    // const hideRoutingDialog = (bRefreshGrid) => {
    //     try{
    //         setarbProgress(100);
    //         if (bRefreshGrid && typeof props.GridRefresh === 'function'){
    //             props.GridRefresh();
    //         }
    //         hideRoutingDialogTimeout.current = setTimeout(() => {
    //             setshowProgressBar(false);
    //             if(typeof props.setManifestBuildDialog === 'function'){
    //                 props.setManifestBuildDialog(false);
    //             }
    //         }, 2000);
    //     }
    //     catch(err){console.log(err);}
    // };

    const NewRouteForcefullly = async (serIDs, schIDs, reqDate, affID, type, manifest, mandatoryGrouping, cbURL, arrObj, SelectedRouteSettingID) => {
        try{
            let Param = {
                "assigned_driver_id": 0,
                "assigned_vehicle_id": 0,
                "service_ids_str": serIDs,
                "schedule_ids_str": schIDs,
                "mini_cluster_type": type,
                "req_date_str": reqDate,
                "manifest_number": manifest,
                "affiliate_id": affID,
                "requested_page_name": "ClusteringActions",
                "mandatory_grouping": mandatoryGrouping,
                "user_id": loginData.iUserID,
                "app_id": 26,
                "selected_records_for_cb": JSON.stringify(arrObj),
                "call_back_url": cbURL,
                "SelectedRouteSettingID": SelectedRouteSettingID
            };
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/MakeRoute", "post", { "Content-Type": "application/json" }, Param, null);
            let result = response.data;
            if (result.run_id > 0) {
                hideRoutingClusteringDialog(true, 'cluster');
                if(typeof props.setGridRefreshPaused === 'function'){
                    props.setGridRefreshPaused(true);
                }
                setshowOnlyMessageDialog({
                    "show": true,
                    "Title": "Force Assignment",
                    "Body": { __html: "Route is being created please wait...", },
                });
            }
            else {
                const errorFlag = (result.Error ? true : false);
                const errorMsg = (errorFlag ? (result.error.includes('system') ? result.error : 'An error occured, please try again.') : 'Something went wrong, please try again later.');
                
                setshowMessageDialog({
                    "show": true,
                    "Title": "Auto Assignment",
                    "Body": { __html: errorMsg, },
                    "btn1_text": "",
                    "btn2_text": "Ok",
                    "Showbtn1Button": false
                });
                // if (result.Error) {
                //     let message = 'Error Occured!!!!';
                //     // console.log(result.error);
                //     if(result.error.includes('system')){
                //         message = result.error
                //     }
                //     setshowMessageDialog({
                //         "show": true,
                //         "Title": "Auto Assignment",
                //         "Body": { __html: message, },
                //         "btn1_text": "",
                //         "btn2_text": "Ok",
                //         "Showbtn1Button": false
                //     });
                // }
                // else {
                //     setshowMessageDialog({
                //         "show": true,
                //         "Title": "Auto Assignment",
                //         "Body": { __html: "Something went wrong!!!!", },
                //         "btn1_text": "",
                //         "btn2_text": "Ok",
                //         "Showbtn1Button": false
                //     });
                // }
            }
        } catch (err){console.log(err);}
    };

    const ARBResponseListener_Identifer = (ManifestPayLoad) => {
        try {
            const ARBResponseMap = {
                StandingRouteMaker: {type: 'ARBResponseListener_StandingRouteMaker', handle: ARBResponseListener_StandingRouteMaker},
                RouteSuggestionMaker: {type: 'ARBResponseListener_RouteSuggestionMaker', handle: ARBResponseListener_RouteSuggestionMaker},
                RouteMaker: {type: 'ARBResponseListener_RouteMaker', handle: ARBResponseListener_RouteMaker},
                RBSProcess: {type: 'ARBResponseListener_RBSProcess', handle: ARBResponseListener_RBSProcess},
                NewRequestHTML: {type: 'ARBResponseListener_NewRequestHTML', handle: ARBResponseListener_NewRequestHTML},
                ClusteringActions: {type: 'ARBResponseListener_ClusteringActions', handle: ARBResponseListener_NewRequestHTML},
                UnClusteringAction: {type: 'ARBResponseListener_UnClusteringAction', handle: ARBResponseListener_NewRequestHTML},
                MTSMResponse: {type: 'ARBResponseListener_MTSMResponse', handle: ARBResponseListener_MTSMResponse},
                PredictiveResponse: {type: 'ARBResponseListener_PredictiveResponse', handle: ARBResponseListener_PredictiveResponse},
                FPTSMResponse: {type: 'ARBResponseListener_FPTSMResponse', handle: ARBResponseListener_FPTSMResponse}
            };
            const dataStr = ManifestPayLoad?.data?.split('||')[1];
            if(dataStr.includes('_')){
                const givenCondition = dataStr.trim().split("_")[1];
                genericResponseHandler(ManifestPayLoad, ARBResponseMap[givenCondition].type, ARBResponseMap[givenCondition].handle);
            }
            if(dataStr === "PredictiveNegotiationResponse")
            {
                const givenCondition = "PredictiveResponse";
                genericResponseHandler(ManifestPayLoad, ARBResponseMap[givenCondition].type, ARBResponseMap[givenCondition].handle);
            }
            // if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_StandingRouteMaker'){
            //     ARBResponseListener_StandingRouteMaker(ManifestPayLoad);
            // }
            // else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_RouteSuggestionMaker'){
            //     ARBResponseListener_RouteSuggestionMaker(ManifestPayLoad);
            // }
            // else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_RouteMaker'){
            //     ARBResponseListener_RouteMaker(ManifestPayLoad);
            // }
            // else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_RBSProcess'){
            //     ARBResponseListener_RBSProcess(ManifestPayLoad);
            // }
            // else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_NewRequestHTML' || ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_ClusteringActions'
            // || ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_UnClusteringAction'){
            //     ARBResponseListener_NewRequestHTML(ManifestPayLoad);
            // }
            // else if(ManifestPayLoad?.data?.split('||')[1] == 'ARBResponseListener_MTSMResponse')
            // {
            //     // console.log(ManifestPayLoad);
            //     ARBResponseListener_MTSMResponse(ManifestPayLoad);
            // }
        }
        catch{}
    };

    function genericResponseHandler (ManifestPayLoad, type = '', handlerFunction) {
        try {
            let _resp = '';
            if (ManifestPayLoad && typeof ManifestPayLoad !== 'undefined' && ManifestPayLoad.data && typeof ManifestPayLoad.data !== 'undefined') {
                _resp = String(ManifestPayLoad.data);
                if(_resp.indexOf("WMRMSUserMessage=") > -1){
                    try {
                        let arrtparams = ManifestPayLoad.data.split("||");
                        let args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
                        if (args !== "") {
                            try {
                                _resp = JSON.parse(args);
                                handlerFunction(_resp);
                            }
                            catch(ex){ console.log(ex); }
                        }
                    }
                    catch(ex) { console.log(ex); }
                }
            }
        }
        catch(err) { console.log(type + " Error: " + err); }
    }

    const ARBResponseListener_MTSMResponse = (_resp) => { //ManifestPayLoad
        try{
            // let _resp = '';
            // if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
            //     _resp = String(ManifestPayLoad.data);
            //     if(_resp.indexOf("WMRMSUserMessage=") > -1)
            //     {
            //         let arrtparams = ManifestPayLoad.data.split("||"); //{“ConfirmationNo”: “001232832”, “TripID”: “231290”, “SchDateTime”: “”, “IsScheduled”: “false”, “Message”: “No Space Available”}
            //         let args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
            //         if (args !== "") {
            //             try{
                            // _resp = JSON.parse(args);
                            let oldDataArr = PersistStorage.retrieve('confirmationsData', false);
                            if(oldDataArr && oldDataArr.length > 0)
                            {
                                for(let l = 0; l < oldDataArr.length; l ++)
                                {
                                    if(String(oldDataArr[l].Confirmation) === String(_resp.message.ConfirmationNo))
                                    {
                                        if(String(_resp.message.IsScheduled)==="true"){
                                            oldDataArr[l].time = _resp.message.SchDateTime;
                                            oldDataArr[l].dropTime = _resp.message.SchDropTime;
                                            oldDataArr[l].msg = _resp.message.Message;
                                            oldDataArr[l].TripID = _resp.message.TripID;
                                        }
                                        else{
                                            oldDataArr[l].msg = _resp.message.Message;
                                            oldDataArr[l].time = "N/A";
                                            oldDataArr[l].dropTime = "N/A";
                                            oldDataArr[l].TripID = _resp.message.TripID;
                                        }
                                        // oldDataArr[l] = {ID: _resp.ConfirmationNo, time: null, name:"", creationTime: new Date(), msg:_resp.Message};
                                    }
                                }
                                    
                                PersistStorage.save('confirmationsData', oldDataArr, 999, false);
                            }
            //             }
            //             catch(ex){console.log(ex);}
            //         }
            //     }
            // }
        }catch (ex) {console.log("ARBResponseListener_MTSMResponse Error: ", ex);}
    };

    const ARBResponseListener_PredictiveResponse = (_resp) => { 
        try{
                console.log(_resp);
                if(_resp !== null){
                    if(typeof props.handlePredictiveResponse === "function"){
                        props.handlePredictiveResponse(_resp);
                    }
                }       
        }catch (ex) {console.log("ARBResponseListener_PredictiveResponse Error: ", ex);}
    };

    const ARBResponseListener_FPTSMResponse = (_resp) => { 
        try{
                console.log(_resp);
                if(_resp !== null){
                    if(typeof props.handlePredictiveResponse === "function"){
                        props.handlePredictiveResponse(_resp);
                    }
                }       
        }catch (ex) {console.log("ARBResponseListener_PredictiveResponse Error: ", ex);}
    };


    const ARBResponseListener_RBSProcess = (_resp) => { //ManifestPayLoad
        try {
            // let _resp = '';
            // if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
            //     _resp = String(ManifestPayLoad.data);
            //     if (_resp.indexOf("WMRMSUserMessage=") > -1) {
            //         try {
            //             let arrtparams = ManifestPayLoad.data.split("||");
            //             let args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
            //             if (args !== "") {
            //                 try {
            //                     _resp = JSON.parse(args);
                                let status = _resp.status?.toLowerCase();
                                let description = _resp.description;
                                let affiliate_id = _resp.affiliate_id;
                                let affiliate_name = _resp.affiliate_name;
                                let user_id = _resp.user_id;
                                let _message = "";

                                if (status === "autoroutingpaused") {
                                    try {
                                        _message = "Auto Route successfully Paused.";
                                        displayMessage(_message);
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }

                                if (status === "autoroutingresumed") {
                                    try {
                                        _message = "Auto Route successfully Resumed.";
                                        displayMessage(_message);
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }

                                if (status === "arbresumednotification") {
                                    let seconds_between_two_events = -1;
                                    try {
                                        if (AutoPausingModalCloseTime != undefined && AutoPausingModalCloseTime != null)
                                            seconds_between_two_events = Math.abs((new Date().getTime() - AutoPausingModalCloseTime.getTime()) / 1000);
                                    } catch (e) {
                                        seconds_between_two_events = -1;
                                    }
                                    let isBrowserTabVisible = (function () {
                                        let stateKey, eventKey, keys = {
                                            hidden: "visibilitychange",
                                            webkitHidden: "webkitvisibilitychange",
                                            mozHidden: "mozvisibilitychange",
                                            msHidden: "msvisibilitychange"
                                        };
                                        for (stateKey in keys) {
                                            if (stateKey in document) {
                                                eventKey = keys[stateKey];
                                                break;
                                            }
                                        }
                                        return function (c) {
                                            if (c) document.addEventListener(eventKey, c);
                                            return !document[stateKey];
                                        }
                                    })();

                                    if (loginData.iUserID === user_id && AutoPausingDialog === false && (seconds_between_two_events === -1 || seconds_between_two_events > 60) && isBrowserTabVisible()) {
                                        //startTimer(description, affiliate_id, affiliate_name);
                                        //if (ARBAutoResumeTimer >= 59) {
                                          
                                            setSelectedDescription(description);
                                            setSelectedAffiliateID(affiliate_id);
                                            StartResumeNotificationTimer(affiliate_name,description,affiliate_id);
                                            
                                            /*
                                            setARBModalObj((prevState) => ({
                                                ...prevState,
                                                show: true,
                                                title: ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
                                                body: `Do you want to Resume Auto-Routing for '${affiliate_name}' date: ${description} ?`,
                                                btnCanceText: 'No',
                                                btnOkText: 'Yes'
                                            }));
                                            
                                            ARBTimer = ARBAutoResumeTimer;
                                            
                                            TimerFunction();

                                            */
                                            // _intervalPlaying = setTimeout(function () {
                                            //     if (ARBAutoResumeTimer <= 0) {
                                            //         ARBAutoResumeTimer = 60;
                                            //         clearInterval(_intervalPlaying);
                                            //         AutoPausingDialog = false;
                                            //         setARBModalObj((prevState) => ({ ...prevState, show: false }));
                                            //         SaveRBSStatus("ResumedARBAutoRouting", 0, description, affiliate_id, 1);
                                            //         console.log("Timer is zero");
                                            //     } else {
                                            //         ARBAutoResumeTimer--;
                                            //         setARBModalObj((prevState) => ({
                                            //             ...prevState,
                                            //             title: affiliate_name + ` Resume Auto Routing | ${ARBAutoResumeTimer}s`,
                                            //         }));
                                            //     }
                                            // }, 1000);
                                        //}
                                    }
                                }
            //                 } catch (ex) {console.log("ARBResponseListener_RBSProcess Error: ",ex);}
            //             }
            //         } catch (ex) {console.log("ARBResponseListener_RBSProcess Error: ",ex);}
            //     }
            // }
        } catch (ex) {console.log("ARBResponseListener_RBSProcess Error: ",ex);}
    };

    const ARBResponseListener_NewRequestHTML = (_resp) => { //ManifestPayLoad
        try {
            // let _resp = '';
            // if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
            //     _resp = String(ManifestPayLoad.data);
            //     if (_resp.indexOf("WMRMSUserMessage=") > -1) {
            //         try {
            //             let arrtparams = ManifestPayLoad.data.split("||");
            //             let args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
            //             if (args !== "") {
            //                 try {
            //                     _resp = JSON.parse(args);
                                if (_resp.status.toUpperCase() === 'SAVEDCOUNT') {
                                    if (parseInt(_resp.message) !== NaN) {
                                        if (parseInt(_resp.message) < 0) {
                                            setshowProgressBar(false);
                                            setarbProgress(1);
                                        }
                                        else if (parseInt(_resp.message) >= 100) {
                                            setarbProgress(100);
                                            if (_resp.description && _resp.description !== '') {
                                                setarbProgressMessage(_resp.description);
                                            }
                                            else {
                                                setarbProgressMessage('Please wait...');
                                            }
                                            props.setAlert(false);
                                        }
                                        else {
                                            setshowProgressBar(true);
                                            setarbProgress(parseInt(_resp.message));
                                            if (_resp.description && _resp.description !== '') {
                                                setarbProgressMessage(_resp.description);
                                            }
                                            else {
                                                setarbProgressMessage('Please wait...');
                                            }
                                            props.setAlert(false);
                                        }
                                    }
                                }
                                else if (_resp.status.toUpperCase() === 'PASS') {
                                    hideRoutingClusteringDialog(true, 'cluster');
                                    hideRoutingClusteringDialog(true, 'route');
                                    props.setGridRefreshPaused(false);
                                    if (_resp.caller.toUpperCase() === 'BATCHROUTING') {
                                        setarbProgress(100);
                                        if(typeof props.GridRefresh === 'function'){
                                            props.GridRefresh();
                                        }

                                        hideRoutingClusteringDialog(true, 'route');
                                        if(typeof props.setGridRefreshPaused === 'function'){
                                            props.setGridRefreshPaused(false);
                                        }
                                        if (_resp._JSON && _resp._JSON !== '') {
                                            let _JSON = JSON.parse(_resp._JSON);
                                            if (_JSON.ViolationString !== "") {
                                                setshowMessageDialog({
                                                    "show": true,
                                                    "Title": "Trips Violation",
                                                    "Body": { __html: _resp.violation_string.replace(new RegExp('\r?\n', 'g'), '<br/>'), },
                                                    "btn1_text": "",
                                                    "btn2_text": "Ok",
                                                    "Showbtn1Button": false
                                                });
                                            }
                                        }
                                         
                                        if (_resp.routeTrips > 0 || _resp.unRouteTrips > 0){
                                            let final_msg =  "From "+ (_resp.routeTrips + _resp.unRouteTrips)+ " trips, " + _resp.routeTrips +" routed into " + _resp.totalRoutes + " routes, " + _resp.unRouteTrips + " trips not routed"
                                            
                                            setshowMessageDialog({
                                                "show": true,
                                                "Title": "Trips Status",
                                                "Body": { __html: final_msg.replace(new RegExp('\r?\n', 'g'), '<br/>'), },
                                                "btn1_text": "",
                                                "btn2_text": "Ok",
                                                "Showbtn1Button": false
                                            });
                                        
                                        }
                                    }
                                    else if (_resp.caller.toUpperCase() === 'SINGLEROUTING') {
                                        let dialog_title = "Routing Results";//"Trips Violation";
                                        setarbProgress(100);

                                        if(typeof props.GridRefresh === 'function'){
                                            props.GridRefresh();
                                        }

                                        //setarbProgress(parseInt(_resp.message));
                                        hideRoutingClusteringDialog(true, 'cluster');
                                        if(typeof props.setGridRefreshPaused === 'function'){
                                            props.setGridRefreshPaused(false);
                                        }
                                        if (_resp._JSON !== undefined && _resp._JSON && _resp._JSON !== '') {
                                            let _JSON = JSON.parse(_resp._JSON);
                                            if (_JSON.ViolationString !== "" && _JSON.ShowConfMsgToForcefullyRouteTrips === true) {
                                                let storedDataJSON = sessionStorage.getItem('RecordIDs');
                                                let storedData = JSON.parse(storedDataJSON);
                                                const setting = JSON.parse(ASCSSettingData[storedData.affID]).find((item)=>item.SubTitle === "HideForceRoutingDialouge")
                                                if(setting?.value === 'true'){
                                                    setUnRoutedRefIDs(_JSON.UnRoutedRefIDs);
                                                    handleForceDispatch(_resp);
                                                }
                                                else{
                                                    if(typeof props.setGridRefreshPaused === 'function'){
                                                        props.setGridRefreshPaused(true);
                                                    }
                                                    setUnRoutedRefIDs(_JSON.UnRoutedRefIDs);
                                                    setshowMessageDialog({
                                                        "show": true,
                                                        "Title": dialog_title,
                                                        "Body": { __html: _resp.violation_string.replace(/\r?\n/g, '<br />'), },
                                                        "btn1_text": "Force Assign",
                                                        "btn2_text": "Cancel",
                                                        "Showbtn1Button": true
                                                    });
                                                }    
                                            }
                                            else if (_JSON.ViolationString !== "") {
                                                if(typeof props.setGridRefreshPaused === 'function'){
                                                    props.setGridRefreshPaused(true);
                                                }
                                                setforceData(_resp);
                                                setshowViolationString(true);
                                                setRouteSuggestionDialog(true);
                                                // setshowMessageDialog
                                                //     (
                                                //         {
                                                //             "show": true,
                                                //             "Title": dialog_title,
                                                //             "Body": { __html: _resp.violation_string.replace(new RegExp('\r?\n', 'g'), '<br />'), },
                                                //             "btn1_text": "",
                                                //             "btn2_text": "Ok",
                                                //             "Showbtn1Button": false
                                                //         }
                                                //     );
                                            }
                                        }
                                        else if (_resp.violation_string !== '') {
                                            handleCloseOnlyMessageDialog();
                                            setshowMessageDialog({
                                                "show": true,
                                                "Title": "Routing Results",
                                                "Body": { __html: _resp.violation_string.replace(new RegExp('\r?\n', 'g'), '<br />'), },
                                                "btn1_text": "",
                                                "btn2_text": "Ok",
                                                "Showbtn1Button": false
                                            });
                                        }
                                        else {

                                            if(typeof props.setGridRefreshPaused === 'function'){
                                                props.setGridRefreshPaused(true);
                                            }
                                            setforceData(_resp);
                                            setRouteSuggestionDialog(true)
                                            // const ARBSelectedOption = PersistStorage.retrieve("ARBSelectedOption", false);
                                            // let StopViewSuggestionData=false;

                                            // FetchStopViewData(_resp).then((result) => {
                                            //     StopViewSuggestionData = result;
                                                
                                            //     if(ARBSelectedOption == 'ForceScheduling' && !StopViewSuggestionData){
                                            //         //handleForceDispatch(_resp)
                                            //         setshowMessageDialog(
                                            //             {
                                            //                 "show": true,
                                            //                 "Title": "Force Scheduling",
                                            //                 "Body": {__html: "Something went wrong!!!!"},
                                            //                 "btn1_text": "",
                                            //                 "btn2_text": "Ok",
                                            //                 "Showbtn1Button": false
                                            //             }
                                            //         );
    
                                            //     }
                                            //     else if(ARBSelectedOption == 'ForceScheduling' && StopViewSuggestionData){
    
                                            //         setforceData(_resp);
                                            //         setRouteSuggestionDialog(true)
    
                                            //     }

                                            // });

                                        }
                                    }
                                    else if (_resp.caller.toUpperCase() === 'UNROUTING') {
                                        if(typeof props.StopViewGridLoad === 'function'){
                                            props.StopViewGridLoad();
                                        }
                                        hideRoutingClusteringDialog(true, 'route');
                                        if(typeof props.setGridRefreshPaused === 'function'){
                                            props.setGridRefreshPaused(false);
                                        }
                                        if(typeof props.GridRefresh === 'function'){
                                            props.GridRefresh();
                                        }
                                    }

                                    else if (_resp.caller.toUpperCase() === 'ROUTESUGGESTIONS') {
                                        setarbProgress(100);
                                        if(typeof props.setRouteSuggestionActionCreate === 'function'){
                                            props.setRouteSuggestionActionCreate(false)
                                        }
                                        if(typeof props.GridRefresh === 'function'){
                                            props.GridRefresh();
                                        }
                                        hideRoutingClusteringDialog(true, 'route');
                                        setforceData(_resp);
                                        if(typeof props.setGridRefreshPaused === 'function'){
                                            props.setGridRefreshPaused(true);
                                        }
                                        // props.setGridRefreshPaused(true);
                                        setRouteSuggestionDialog(true);
                                    }
                                }
                                else if (_resp.status.toUpperCase() === 'FAIL') {
                                    // console.log(ManifestPayLoad);
                                    if(typeof props.GridRefresh === 'function'){
                                        props.GridRefresh();
                                    }
                                    hideRoutingClusteringDialog(false, 'cluster');
                                    if(typeof props.setRouteSuggestionActionCreate === 'function'){
                                        props.setRouteSuggestionActionCreate(false);
                                    }
                                    if(typeof props.setGridRefreshPaused === 'function'){
                                        props.setGridRefreshPaused(false);
                                    }
                                    // props.setGridRefreshPaused(false);
                                    hideRoutingClusteringDialog(false, 'route');
                                    setshowMessageDialog({
                                        "show": true,
                                        "Title": "Routing Actions",
                                        "Body": { __html: (_resp.message === "" ? "Action failed" : _resp.message) },
                                        "btn1_text": "",
                                        "btn2_text": "Ok",
                                        "Showbtn1Button": false
                                    });
                                }
            //                 } catch (koip) { }
            //             }
            //         } catch (qawdfr) { }
            //     }
            // }
        } catch (err) {console.log('ARBResponseListener Error: ' + err);}
    };

    const ARBResponseListener_RouteSuggestionMaker = (_resp) => { //ManifestPayLoad
        try {
            // let _resp = '';
            // if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
            //     _resp = String(ManifestPayLoad.data);
            //     if (_resp.indexOf("WMRMSUserMessage=") > -1) {
            //         try {
            //             let arrtparams = ManifestPayLoad.data.split("||");
            //             let args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
            //             if (args !== "") {
            //                 try {
            //                     _resp = JSON.parse(args);
                                if (_resp.status?.toUpperCase() === 'SAVEDCOUNT') {
                              
                                }
                                else if (_resp.status?.toUpperCase() === 'PASS') {
                                    setarbProgress(5);
                                    setshowProgressBar(true);
                                    let responseData = _resp.data;
                                    if (_resp.caller?.toUpperCase() === 'VALIDATEROUTE') {
                                        if(responseData && responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForRouteSuggestionValidate"}));
                                        }
                                        else{
                                            setshowMessageDialog({
                                                "show": true,
                                                "Title": "Routing Actions",
                                                "Body": { __html: (_resp.message === "" ? "No Violation Found" : _resp.message) },
                                                "btn1_text": "",
                                                "btn2_text": "Ok",
                                                "Showbtn1Button": false
                                            });
                                        }
                                        ARBSetTimeout.current = setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        ARBSetTimeout_1.current = setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);
                                    }
                                    else{
                                        if(responseData && responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForRouteSuggestionAdjustTime"}));
                                        }
                                    }
                                }
                                else if (_resp.status?.toUpperCase() === 'FAIL') {
                                    if(typeof props.setAlert === 'function'){
                                        props.setAlert(false);
                                    }
                                    setarbProgress(50);
                                    setshowProgressBar(true);
                                   

                                    if(_resp.message.toLowerCase() === "voilation result is null"){
                                        ARBSetTimeout_2.current = setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        dispatch(SetARBResponsePersistData({data: [1], name:"ARBResponseForRouteSuggestionNoViolation"}));
                                        ARBSetTimeout_3.current = setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);
                                    }
                                    else{
                                        ARBSetTimeout_4.current = setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        ARBSetTimeout_5.current = setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);

                                        setshowMessageDialog({
                                            "show": true,
                                            "Title": "Routing Actions",
                                            "Body": { __html: (_resp.message === "" ? "Action failed" : _resp.message) },
                                            "btn1_text": "",
                                            "btn2_text": "Ok",
                                            "Showbtn1Button": false
                                        });
                                    }  
                                }
            //                 } catch(ex){console.log(ex);}
            //             }
            //         } catch(ex){console.log(ex);}
            //     }
            // }
        } catch(ex){console.log(ex);}
    };

    const ARBResponseListener_StandingRouteMaker = (_resp) => { //ManifestPayLoad
        try {
            // let _resp = '';
            // if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
            //     _resp = String(ManifestPayLoad.data);
            //     if (_resp.indexOf("WMRMSUserMessage=") > -1) {
            //         try {
            //             let arrtparams = ManifestPayLoad.data.split("||");
            //             let args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
            //             if (args !== "") {
            //                 try {
            //                     _resp = JSON.parse(args);
                                if (_resp.status?.toUpperCase() === 'SAVEDCOUNT') {
                              
                                }
                                else if (_resp.status?.toUpperCase() === 'PASS') {
                                    setarbProgress(5);
                                    setshowProgressBar(true);
                                    let responseData = _resp.data;
                                    if (_resp.caller?.toUpperCase() === 'VALIDATEROUTE') {
                                        if(responseData && responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForValidate"}));
                                        }
                                        ARBStandingRouteMakerSetTimeout.current = setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        ARBStandingRouteMakerSetTimeout_1.current = setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);
                                    }
                                    else{
                                        if(responseData && responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForAdjustTime"}));
                                        }
                                    }
                                }
            //                 } catch(ex){console.log(ex);}
            //             }
            //         } catch(ex){console.log(ex);}
            //     }
            // }
        } catch(ex){console.log(ex);}
    };

    const ARBResponseListener_RouteMaker = (_resp) => { //ManifestPayLoad
        try {
            // let _resp = '';
            // if (ManifestPayLoad !== undefined && ManifestPayLoad !== null && ManifestPayLoad.data !== undefined && ManifestPayLoad.data !== null) {
            //     _resp = String(ManifestPayLoad.data);
            //     if (_resp.indexOf("WMRMSUserMessage=") > -1) {
            //         try {
            //             let arrtparams = ManifestPayLoad.data.split("||");
            //             let args = arrtparams[0].replace((new RegExp("WMRMSUserMessage=", 'g')), "");
            //             if (args !== "") {
            //                 try {
            //                     _resp = JSON.parse(args);
                                if (_resp.status?.toUpperCase() === 'SAVEDCOUNT') {
                                    // console.log(ManifestPayLoad);

                                }
                                else if (_resp.status?.toUpperCase() === 'PASS') {
                                    // console.log(ManifestPayLoad);
                                    setarbProgress(5);
                                    setshowProgressBar(true);
                                    let responseData = _resp.data;
                                    if (_resp.caller?.toUpperCase() === 'VALIDATEROUTE') {
                                        if(responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForStopViewValidate"}));
                                        }
                                        ARBRouteListenerSetTimeout.current = setTimeout(function () {
                                            setarbProgress(100);
                                            setshowProgressBar(true);
                                        }, 1000);
                                        if(typeof props.setAlert === 'function'){
                                            props.setAlert(false);
                                        }
                                        ARBRouteListenerSetTimeout_1.current = setTimeout(function () {
                                            setshowProgressBar(false);
                                        }, 2000);
                                        
                                    }
                                    else{
                                        if(responseData.length > 0){
                                            dispatch(SetARBResponsePersistData({data: responseData, name:"ARBResponseForStopViewComputeEstimates"}));
                                        }
                                    }
                                }
                                else if (_resp.status?.toUpperCase() === 'FAIL') {
                                    if(typeof props.setAlert === 'function'){
                                        props.setAlert(false);
                                    }
                                    setshowMessageDialog
                                    (
                                        {
                                            "show": true,
                                            "Title": "Routing Actions",
                                            "Body": { __html: (_resp.message === "" ? "Action failed" : _resp.message) },
                                            "btn1_text": "",
                                            "btn2_text": "Ok",
                                            "Showbtn1Button": false
                                        }
                                    );
                                }
            //                 } catch(ex){console.log(ex);}
            //             }
            //         } catch(ex){console.log(ex);}
            //     }
            // }
        } catch(ex){console.log(ex);}
    };

    const SaveRBSStatus = async (ServiceStatus, iPauseAutoRouting, dtServiceDate, affilateId, iActionSource = 0) => { //1 = iActionSource Clicked from AutoResume Popup
        try {
            if (ServiceStatus === "StopFromMBPC") {//MBPC screen during Routing
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID, "post", { "Content-Type": "application/json" }, null, null);
                setARBModalObj((prevState) => ({ ...prevState, show: false }));
            }
            else if (ServiceStatus === "StopFromCallTaker" || ServiceStatus === "ResumedARBAutoRouting") {
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID, "post", { "Content-Type": "application/json" }, null, null);
                setARBModalObj((prevState) => ({ ...prevState, show: false }));
            } else {
                setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Auto Routing', body: "Are you Sure you want to " + ServiceStatus + " Auto-Routing?", btnCanceText: 'No', btnOkText: 'Yes' }));
                let myData = "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + loginData.iUserID;
                sessionStorage.setItem('ARBProcessStatus', myData);

            }
        } catch (ex) {console.log(ex);}
    };

    // const handleConfirmationModalCancel = () => {
    //     setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    // };

    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    };
    
    const handleConfirmationModalOk = () => {
        try{
            let storedDataJSON = sessionStorage.getItem('ARBProcessStatus');
            let response = APICom.fetchData("GenericManifestDotNetCoreURL", storedDataJSON, "post", { "Content-Type": "application/json" }, null, null);
            setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        }
        catch(err){console.log(err);}
    };

    const handleCloseRouting = () => {
        setMessageVisible((prevState) => ({ ...prevState, show: false, body: ""}));
    };

    // const FetchStopViewData = async (_resp) => {
    //     try{
    //         const forceSelectedDate = PersistStorage.retrieve("forceSelectedDate", false);
    //         const forceManifestId = PersistStorage.retrieve("forceManifestId", false);
    //         const routeId = forceManifestId?.substring(8);
    //         let params = {
    //         "iRunID": String(_resp.run_id),
    //         "RouteID": routeId,
    //         "selectedDate": forceSelectedDate
    //         }
    //         let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StopsOnRouteSuggestion", "post", { "Content-Type": "application/json" }, params, null);
    //         if (response?.data != null && response?.data?.StopView?.length > 0){
    //             return true;
    //             // setforceData(_resp);
    //             // setRouteSuggestionDialog(true)
    //         }

    //         else{
    //             return false;
    //             // setshowMessageDialog
    //             // (
    //             //     {
    //             //         "show": true,
    //             //         "Title": "Routing Results",
    //             //         "Body": { __html: _resp.violation_string.replace(new RegExp('\r?\n', 'g'), '<br />'), },
    //             //         "btn1_text": "",
    //             //         "btn2_text": "Ok",
    //             //         "Showbtn1Button": false
    //             //     }
    //             // );
    //         }
    //     }
    //     catch(err){console.log(err);}
    // };


    return (
        <>
            <div style={{ display: 'none' }}>
                <iframe
                    src={P_MasterASCSCallerIDIframeURL + '/WMRMS/WMRMSCommonCom'}
                    ref={iframeRef}
                    id='WMRMSCommonComifra'
                    className="WMRMSCommonComifra"
                    onLoad={handleIframeLoad}
                    style={{
                        overflow: 'auto',
                        position: 'fixed',
                        top: '145px',
                        left: '50px',
                        height: '600px',
                        width: '80%',
                        zIndex: '7777',
                        border: '1px solid black'
                    }}
                />
                <Button onClick={(e)=>{setshowiFrame(false);}} variant="dark" style={{
                    overflow: 'auto',
                    position: 'fixed',
                    top: '745px',
                    left: '50px',
                    width: '10%',
                    zIndex: '7777'
                }}>Close</Button>
            </div>
            {showProgressBar && multiPageProgressBar ? <ARBProgressBar value={arbProgress} message={arbProgressMessage} /> : ''}
            <Modal show={showMessageDialog.show && showARBValidationMsg  ? 1 : 0} centered onHide={handleCloseClusteringDialog} aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {showMessageDialog.Title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div dangerouslySetInnerHTML={showMessageDialog.Body} />
                </Modal.Body>
                <Modal.Footer>
                    {showMessageDialog.Showbtn1Button ? <Button variant="dark" onClick={handleForceDispatch}>{showMessageDialog.btn1_text}</Button> : ""}
                    <Button variant="dark" onClick={handleCloseClusteringDialog}>{showMessageDialog.btn2_text}</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showOnlyMessageDialog.show && showARBValidationMsg ? 1 : 0} centered aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        {showOnlyMessageDialog.Title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div dangerouslySetInnerHTML={showOnlyMessageDialog.Body} />
                </Modal.Body>
            </Modal>

            {showARBValidationMsg &&
            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalClose} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
                btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" 
                ShowTimer={confirmationModalObj.ShowTimer} timerDuration ={confirmationModalObj.timerDuration}
                onTimerExpire={confirmationModalObj.onTimerExpire}
            />
            }


            {showARBValidationMsg &&
                <ConfirmationModal centered  // Add the centered prop
                    aria-labelledby="contained-modal-title-vcenter" show={ARBModalObj.show} Title={ARBModalObj.title} Body={ARBModalObj.body}
                    onOk={()=>{handleConfirmationModalButtonPress();}} onCancel={()=>{handleConfirmationModalButtonPress(2);}} 
                    onClose={()=>{handleConfirmationModalButtonPress(2);}} btnCanceText={ARBModalObj.btnCanceText}
                    btnOkText={ARBModalObj.btnOkText} ShowCancelButton="true" ShowTimer={ARBModalObj.ShowTimer} timerDuration ={ARBModalObj.timerDuration}
                    handleOnTimerExpire={()=>{handleConfirmationModalButtonPress();}} 
                />
            }

            <Modal show={isMessageVisible.show && showARBValidationMsg ? 1 : 0} centered onHide={handleCloseRouting} aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Routing
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example">
                    {isMessageVisible.body}
                </Modal.Body>
                <Modal.Footer>
                  
                </Modal.Footer>
            </Modal>
            {showForceSchedulingComponent ? 
                <ForceSchedulingComponent  showForceSchedulingComponent={showForceSchedulingComponent} 
                    setshowForceSchedulingComponent= {setshowForceSchedulingComponent} forceData= {forceData} stopViewGridData= {stopViewGridData}
                /> 
            : "" }
            
            {showRouteSuggestionDialog && loginData.BuildManifestDispatchID && showARBValidationMsg ? 
                <RouteSuggestion 
                    setRouteSuggestionDialog={setRouteSuggestionDialog} showRouteSuggestionDialog = {showRouteSuggestionDialog} forceData={forceData} 
                    reArrangedRowsFlag={rowReArrangeCheck} setReArrangeFlag={setRowReArrangeCheck} handleCloseOnlyMessageDialog={handleCloseOnlyMessageDialog}
                    showViolationString = {showViolationString} setGridRefreshPaused = {props.setGridRefreshPaused}
                /> 
            : "" }
        </>
    );
};

export default ARBResponseListener;
